////////LIBRARY/////////
import { isNull } from 'lodash'
///////////////////////////
//      API ENDPOINT      //
/////////////////////////

//************************************************************
///////////////////////////
//        START         //
//      CONSTANT        //
/////////////////////////
// Distributor
/**
 * distributor url config
 * @param   {string}        id distributor of user
 * @returns {string}        /distributors/'id'
 */
export function DISTRIBUTORS(id) {
	return `/distributors/${id}`
} // END FUNCTION

// STORE
/**
 *
 * @param   {string}     id store of user
 * @return  {string}     /stores/'id'
 */
export function STORE(id) {
	return `/stores/${id}`
} // END FUNCTION

// KIOSK
/**
 * api start with store and kiosk
 * @param   {string}    id id kiosk select by user
 * @returns {string}    /kiosks/'id'
 */
export function KIOSK(id) {
	return `/kiosks/${id}`
} // END FUNCTION

//region CREATE QUERY PARAMS ...

/**
 * @example
 * queryParam:{
 *     page: "5",
 *     size: '50'
 * }
 *
 * @param {object} queryParams
 * @return {string}
 */
function createQueryParams(queryParams) {
	let queryParamSend = queryParams?.page ? `?page=${queryParams?.page}` : '?'
	queryParamSend += queryParams?.size ? `&size=${queryParams?.size}` : ''
	queryParamSend += queryParams?.action ? `&action=${queryParams?.action}` : ''
	queryParamSend += queryParams?.sort && queryParams?.nameDir ? `&sort=${queryParams?.sort},${queryParams?.nameDir}` : ''
	queryParamSend += queryParams?.sort_2 && queryParams?.nameDir_2 ? `&sort=${queryParams?.sort_2},${queryParams?.nameDir_2}` : ''
	queryParamSend += queryParams?.sort_3 && queryParams?.nameDir_3 ? `&sort=${queryParams?.sort_3},${queryParams?.nameDir_3}` : ''
	queryParamSend += queryParams?.sort_4 && queryParams?.nameDir_4 ? `&sort=${queryParams?.sort_4},${queryParams?.nameDir_4}` : ''
	queryParamSend += queryParams?.sort && !queryParams?.nameDir ? `&sort=${queryParams?.sort}` : ''
	queryParamSend += queryParams?.order ? `&order=${queryParams?.order}` : ''
	return queryParamSend
}

//endregion

///////////////////////////
//        END           //
//      CONSTANT        //
/////////////////////////
//************************************************************

//************************************************************
// LOGIN
/**
 *
 * @returns {string}
 */
export function GET_BEARER_TOKEN() {
	return `/auth/jwt?`
}
/**
 *
 * @returns {string}
 */
export function GET_CURRENT_USER() {
	return `/current-user`
}

/**
 *
 * @returns {string}            /forgot-password
 */
export function POST_FORGOT_PASSWORD() {
	return `/forgot-password`
}

/**
 *
 * @returns {string}            /forgot-login
 */
export function POST_FORGOT_LOGIN() {
	return `/forgot-username`
}
//************************************************************

//************************************************************
// languages
/**
 *
 * @returns {string}        /languages
 */
export function GET_LANGUAGE_ENABLED() {
	return `/languages` + `/public`
} // END FUNCTION

/**
 *  @param      {string}        idLanguage
 *  @returns    {string}        /translations/languages/'id'
 */
export function GET_TRANSLATION_LANGUAGES_BY_ID(idLanguage) {
	return `/translations` + `/languages/${idLanguage}`
} // END FUNCTION

/**
 *  @param      {string}        idLanguage
 *  @returns    {string}        /translations/languages/'id'/public
 */
// /distributors/1/kiosks/1/salesorders/2/customer-info/update
export function GET_TRANSLATION_LANGUAGES_PUBLIC_BY_ID(idLanguage) {
	return `/translations` + `/languages/${idLanguage}` + `/public`
} // END FUNCTION
//************************************************************

//************************************************************
// users manager
/**
 * @returns {string}       /users
 */
export function GET_ADMIN_USERS(queryParams) {
	return `/users${createQueryParams(queryParams)}`
} // END FUNCTION

// user detail
/**
 *  @param  {Object}        ids
 * @returns {string}        /users/'id'
 */
export function GET_USER_DETAIL(ids) {
	return `/users/${ids.idUser}`
} // END FUNCTION

/**
 *
 * @param   {Object}        ids
 * @returns {string}        /companytyped/users/create
 */
export function POST_USER_CREATE() {
	return `/users/create`
} // END FUNCTION

/**
 * @param   {Object}        ids
 * @returns {string}        /companytyped/'id'/users/'id'/update
 */
export function UPDATE_USER_DETAIL(ids) {
	return `/users/${ids.idUser}/update`
} // END FUNCTION

/**
 * @param {Object}          ids
 * @returns {string}         /company/users/'id'
 */
export function DELETE_ADMIN_USER(ids) {
	return `/users/${ids.idUser}?action=delete`
} // END FUNCTION

/**
 *
 * @param   {Object}        ids
 * @returns {string}       /users/'id'/reset-password
 */
export function USER_DETAIL_RESET_PASSWORD(ids) {
	return `/users/${ids.idUser}/reset-password`
} // END FUNCTION

/**
 * @param {Object}          ids
 * @returns {string}        /company/users/'id'
 */
export function DISABLED_ADMIN_USER(ids) {
	return `/users/${ids.idUser}?action=disable`
} // END FUNCTION
//************************************************************

//************************************************************
// roles manager
/**
 * @param {Object}          ids
 * @returns {string}        /roles
 */
export function GET_ROLES(ids) {
	return ids.userMode ? `/roles/userdetail` : `/roles`
} // END FUNCTION

/**
 *
 * @param   {Object}        ids
 * @returns {string}        /roles/create
 */
export function CREATE_ROLE(ids) {
	return `/roles/create`
} // END FUNCTION

/**
 * @param {Object}          ids
 * @returns {string}         /roles/'id'/delete
 */
export function DELETE_ROLE(ids) {
	return `/roles/${ids.idRole}` + `/delete`
} // END FUNCTION

// role detail
/**
 *  @param  {Object}        ids
 * @returns {string}        /roles/'id'
 */
export function GET_ROLE_DETAIL(ids) {
	return `/roles/${ids.idRole}`
} // END FUNCTON

/**
 *
 * @param   {Object}        ids
 * @returns {string}        /roles/'id'/header/update
 */
export function UPDATE_HEADER_ROLE(ids) {
	return `/roles/${ids.idRole}/header/update`
} // END FUNCTION

/**
 *
 * @param   {Object}        ids
 * @returns {string}        /roles/'id'/content/update
 */
export function UPDATE_CONTENT_ROLE(ids) {
	return `/roles/${ids.idRole}/content/update`
} // END FUNCTION

//************************************************************
// tags manager
/**
 * @param {Object}          ids
 * @returns {string}        /tags
 */
export function GET_TAGS(ids) {
	return `/tags`
} // END FUNCTION

/**
 *
 * @param   {Object}        ids
 * @returns {string}        /tags/create
 */
export function CREATE_TAG(ids) {
	return `/tags/create`
} // END FUNCTION

/**
 *
 * @param   {Object}        ids
 * @returns {string}        /tags/create
 */
export function GET_TAG_DETAIL(ids) {
	return ids.requestType === 'user' ? `/tags/users/company` : `/tags/kiosks/company`
} // END FUNCTION

/**
 * @param {Object}          ids
 * @returns {string}         /tags/'id'/delete
 */
export function DELETE_TAG(ids) {
	return `/tags/${ids.idTag}` + `/delete`
} // END FUNCTION

/**
 *
 * @param   {Object}        ids
 * @returns {string}        /tags/'id'/update
 */
export function UPDATE_TAG_HEADER(ids) {
	return `/tags/${ids.idTag}/update`
} // END FUNCTION

/**
 *
 * @param   {Object}        ids
 * @returns {string}        /tags/'mode'/update
 */
export function UPDATE_TAG_CONTENT(ids) {
	return ids.mode === 'user' ? `/tags/users/update` : `/tags/kiosks/update`
} // END FUNCTION

//************************************************************

// account detail
/**
 * @returns {string}        /current-user/my-account
 */
export function GET_ACCOUNT() {
	return `/current-user/my-account`
} // END FUNCTION

/**
 * @returns {string}        /current-user/my-account
 */
export function UPDATE_ACCOUNT() {
	return `/current-user/my-account/update`
} // END FUNCTION

// kiosk perimeter
/**
 * @param {Object}          ids
 * @returns {string}        /current-user/kiosks-scopes
 */
export function GET_PERIMETERS(ids) {
	return `/current-user/kiosks-scopes`
} // END FUNCTION

/**
 *
 * @returns {string}        /current-user/tags
 */
export function GET_TAGS_PERIMETER() {
	return `/current-user/tags`
} // END FUNCTION

/**
 *  @param  {Object}        ids
 * @returns {string}        /current-user/kiosks-scopes/'id'
 */
export function GET_PERIMETER(ids) {
	return `/current-user/kiosks-scopes/${ids.idPerimeter}`
} // END FUNCTON

/**
 *  @param  {Object}        ids
 * @returns {string}        /current-user/kiosks-scope/kiosks
 */
export function GET_KIOSKS_WITH_CRITERIA(ids) {
	return `/current-user/kiosk-scope/kiosks`
} // END FUNCTON

/**
 *
 * @param   {Object}        ids
 * @returns {string}        /current-user/kiosk-scope/create
 */
export function CREATE_PERIMETER(ids) {
	return `/current-user/kiosk-scope/create`
} // END FUNCTION

/**
 *
 * @param   {Object}        ids
 * @returns {string}        /current-user/kiosk-scope/'id'/update
 */
export function UPDATE_PERIMETER(ids) {
	return `/current-user/kiosk-scope/${ids.idPerimeter}/update`
} // END FUNCTION

/**
 * @param {Object}          ids
 * @returns {string}        /current-user/kiosks-scopes/'id'/delete
 */
export function DELETE_PERIMETER(ids) {
	return `/current-user/kiosks-scopes/${ids.idPerimeter}` + `/delete`
} // END FUNCTION

//************************************************************

//region RECAP STOCK ...
//************************************************************
// RECAP STOCK
/**
 *
 * @param {object} queryParams
 * @return {string}
 * @constructor
 */
export function POST_RECAP_STOCK(queryParams) {
	return `current-user/stocks/summary${createQueryParams(queryParams)}`
}

/**
 *
 * @param {object} queryParams
 * @return {string}
 * @constructor
 */
export function POST_RECAP_STOCK_FROM_REDIRECT(queryParams) {
	return `/current-user/stocks/summary/filters${createQueryParams(queryParams)}`
}

/**
 *
 * @return {string}
 * @constructor
 */
export function PUT_RECAP_STOCK() {
	return `/current-user/stocks/stockalerts/update`
}

//************************************************************
//endregion

// CONSIGNATION
/**
 * @param {object} queryParams
 * @returns {string}
 * @constructor
 */
export function POST_CONSIGNATION(queryParams) {
	return `/current-user/consignment${createQueryParams(queryParams)}`
}

/**
 *
 * @return {string}
 * @constructor
 */
export function UPDATE_CUSTOMER_INFOS() {
	return `/current-user/consignment/customer/update`
}

/**
 * @param {Object}          ids
 * @return {string}
 * @constructor  //
 */

export function SEND_CONSIGNEMENT_CONTRACT(ids) {
	return `/current-user/consignment/contract/${ids}` + `/send`
}

/**
 * @param {Object}          ids
 * @return {string}
 * @constructor  //
 */

export function VIEW_CONSIGNEMENT_CONTRACT(ids) {
	return `/current-user/consignment/contract/${ids}` + `/see`
}

// END FUNCTION

// sales history
/**
 * @param {Object}          ids
 * @returns {string}        /current-user/salesorders
 */
export function GET_SALES_HISTORY(ids, queryParams) {
	return `/current-user/salesorders${createQueryParams(queryParams)}`
}
// END FUNCTION

/**
 * @param {Object}          idSale
 * @returns {string}        /current-user/salesorders/'id'
 */
export function SEND_MERCHANT_TICKET(idSale) {
	return `/current-user/salesorders/${idSale}?action=sendMerchandTicket`
}
// END FUNCTION

/**
 * @param {Object}          idSale
 * @returns {string}        /current-user/salesorders/'id'/customer-ticket
 */
export function SEND_GUEST_TICKET(idSale) {
	return `/current-user/salesorders/${idSale}/customer-ticket`
}
// END FUNCTION

// scheduled prices manager
/**
 * @param {Object}          ids
 * @returns {string}        /current-user/price-update
 */
export function GET_SCHEDULED_PRICES(ids, queryParams) {
	return `/current-user/price-update/campaigns${createQueryParams(queryParams)}`
}
// END FUNCTION

/**
 * @param {Object}          ids
 * @returns {string}        /current-user/price-update/'id'/transmition
 */
export function GET_TRANSMISSION(idCampaign) {
	return `/current-user/price-update/campaigns/${idCampaign}/transmition`
}
// END FUNCTION

/**
 * @param {Object}          ids
 * @returns {string}        /current-user/price-update/'id'
 */
export function GET_CAMPAIGN(idCampaign) {
	return `/current-user/price-update/campaigns/${idCampaign}`
}
// END FUNCTION

/**
 * @param {Object}          ids
 * @returns {string}        /current-user/price-update/'id'/update
 */
export function UPDATE_CAMPAIGN(idCampaign) {
	return `/current-user/price-update/campaigns/${idCampaign}/update`
}
// END FUNCTION

/**
 *
 * @return {string}
 * @constructor
 */
export function CHECK_ITEMS_CAMPAIGN(target) {
	return `/current-user/price-update/campaigns/new-campaign?action=${target}`
}

/**
 * @param {Object}          ids
 * @returns {string}        /current-user/price-update/'id'/cancel
 */
export function CANCEL_CAMPAIGN(idCampaign) {
	return `/current-user/price-update/campaigns/${idCampaign}/cancel`
}

/**
 * @param {Object}          ids
 * @returns {string}        /current-user/price-update/campaigns/create
 */
export function CREATE_CAMPAIGN(queryParam) {
	return `/current-user/price-update/campaigns/create?action=${queryParam}`
}
// END FUNCTION

/**
 *
 * @param {string} idCampaign
 * @param {bool} withTtc
 * @returns {string}
 */
export function GET_PRICE_CAMPAIGN_NESTED_LINES(idCampaign, withTtc) {
	return `/current-user/price-update/campaigns/${idCampaign}?withTTC=${withTtc}`
}

// prices manager by article
/**
 * @param {Object}          ids
 * @returns {string}        /current-user/prices-manager
 */
export function GET_PRICES_ARTICLE(ids, queryParams) {
	return `/current-user/prices-manager${createQueryParams(queryParams)}`
}

// END FUNCTION

// kiosk prices manager

/**
 * @returns {string}        current-user/prices-manager
 */
export function POST_KIOSK_PRICES_MANAGER(queryParams) {
	return `current-user/prices-manager${createQueryParams(queryParams)}` + `&action=byKiosk`
} // END FUNCTION

/////PROMO////

/**
 * @returns {string}        /promotions/campaigns
 */
export function GET_SCHEDULED_PROMO(queryParams) {
	return `/promotions/campaigns${createQueryParams(queryParams)}`
}
// END FUNCTION
/**
 * @param {Object}          ids
 * @returns {string}        /promotions/campaigns/'id'
 */
export function GET_CAMPAIGN_PROMO(idCampaign) {
	return `/promotions/campaigns/${idCampaign}`
}
// END FUNCTION

/**
 * @param {Object}          ids
 * @returns {string}        /promotions/campaigns/'id'/update
 */
export function UPDATE_CAMPAIGN_PROMO(idCampaign) {
	return `/promotions/campaigns/${idCampaign}/update`
} // END FUNCTION

/**
 * @param {Object}          ids
 * @returns {string}        /promotions/campaigns/'id'/transmition
 */
export function GET_TRANSMISSION_PROMO(idCampaign) {
	return `/promotions/campaigns/${idCampaign}/transmission`
}
// END FUNCTION

/**
 *
 * @return {string}
 * @constructor
 */
export function CHECK_ITEMS_CAMPAIGN_PROMO(target) {
	return `/promotions/campaigns/new-campaign?action=${target}`
} // END FUNCTION

/**
 * @param {Object}          ids
 * @returns {string}        /current-user/price-update/campaigns/create
 */
export function CREATE_CAMPAIGN_PROMO(queryParam) {
	return `/promotions/campaigns/create?action=${queryParam}`
} // END FUNCTION

/**
 * @param {Object}          ids
 * @returns {string}        /current-user/price-update/'id'/cancel
 */
export function CANCEL_CAMPAIGN_PROMO(idCampaign) {
	return `/promotions/campaigns/${idCampaign}/cancel`
}

/**
 *
 * @param {string} idCampaign
 *  * @param {bool} withTtc
 * @returns {string}
 */
export function GET_PROMO_CAMPAIGN_NESTED_LINES(idCampaign, withTtc) {
	return `promotions/campaigns/${idCampaign}?withTTC=${withTtc}`
}

////END PROMO /////
//************************************************************

// rgpd search customer

/**
 * @returns {string}        current-user/prices-manager
 */
export function POST_SEARCH_CUTOMER(queryParams) {
	return `/current-user/rgpd/searchCustomer${createQueryParams(queryParams)}`
}
// END FUNCTION
//************************************************************

// rgpd  customer data

/**
 * @returns {string}        /current-user/rgpd/summaryData
 */
export function POST_CUSTOMER_DATA() {
	return `/current-user/rgpd/summaryData`
}
// END FUNCTION
//************************************************************

// rgpd  anonymise data

/**
 * @returns {string}        /current-user/rgpd/anonymize
 */
export function POST_ANONYMISE_DATA() {
	return `/current-user/rgpd/anonymize`
}
// END FUNCTION
//************************************************************

///////////////////////////LOG///////////////////////////////////

// Log user
/**
 *
 * @returns {string}        /current-user/logs/users
 */
export function POST_LOG_USERS(queryParams) {
	return `/current-user/logs/users${createQueryParams(queryParams)}`
}

// END FUNCTION

// Log kiosk
/**
 *
 * @returns {string}        /current-user/logs/kiosks
 */
export function POST_LOG_KIOSK(queryParams) {
	return `/current-user/logs/kiosks${createQueryParams(queryParams)}`
}

// END FUNCTION

// Log synchro
/**
 *
 * @returns {string}       /current-user/logs/synchro
 */
export function POST_LOG_SYNCHRO(queryParams) {
	return `/current-user/logs/synchro${createQueryParams(queryParams)}`
}

// END FUNCTION

// Log extranet
/**
 *
 * @returns {string}       /current-user/logs/extranet
 */
export function POST_LOG_EXTRANET(queryParams) {
	return `/current-user/logs/extranet${createQueryParams(queryParams)}`
}

// END FUNCTION

// telecollects
/**
 * @param {Object}          ids
 * @param {object}          queryParams
 * @returns {string}        /current-user/payments-collection
 */
export function GET_TELECOLLECTS(ids, queryParams) {
	return `/current-user/payments-collection${createQueryParams(queryParams)}`
}

/**
 *  @param  {Object}        idTelecollect
 * @returns {string}        current-user/payments-collection/'id'
 */
export function GET_TELECOLLECT_HEADER(idTelecollect) {
	return `/current-user/payments-collection/${idTelecollect}`
}

/**
 * @param {Object}          ids
 * @param {string}          action
 * @returns {string}        /current-user/payments-collection/'id'/salesOrders
 */
export function GET_TELECOLLECT_DETAIL_ITEMS(ids, action) {
	return `/current-user/payments-collection/${ids}/salesOrders?action=${action}`
}

/**
 * @param {string}          idTelecollect
 * @param {string}          idSale
 * @returns {string}        /current-user/payments-collection/'idTelecollect'/salesOrders/'idSale'
 */
export function GET_TELECOLLECT_DETAIL_SALE(idTelecollect, idSale) {
	return `/current-user/payments-collection/${idTelecollect}/salesOrders/${idSale}`
}

/**
 * @param {string}          idTelecollect
 * @returns {string}        /current-user/payments-collection/'idTelecollect'/to-comparison-success
 */
export function SET_TELECOLLECT_COMPARISON(idTelecollect) {
	return `/current-user/payments-collection/${idTelecollect}/to-comparison-success`
}

/**
 *  @param  {Object}        idTelecollect
 * @returns {string}        current-user/payments-collection/'id'
 * Is the same return has GET_TELECOLLECT_HEADER, but used in GET method
 */
export function GET_TELECOLLECT_TICKET(idTelecollect) {
	return `/current-user/payments-collection/${idTelecollect}`
}

// sales by article history
/**
 * @param {Object}          ids
 * @returns {string}        /current-user/salesorders/byItem
 */
export function GET_SALES_BY_ARTICLE_HISTORY(ids, queryParams) {
	return `/current-user/salesorders/byItem${createQueryParams(queryParams)}`
}
// END FUNCTION

// Sales history by codes
/**
 *
 * @returns {string}       /current-user/codes/summary
 */
export function GET_HISTO_CODE(queryParams) {
	return `/current-user/codes/summary${createQueryParams(queryParams)}`
}

// END FUNCTION

// Display ticket codes
/**
 * @param {Object}          ids
 * @returns {string}        /current-user/codes/'id'/display
 */
export function POST_DISPLAY_TICKET(salesOrderId) {
	return `/current-user/codes/${salesOrderId}/display`
}
// END FUNCTION

// Review ticket codes
/**
 * @param {Object}          ids
 * @returns {string}        /current-user/codes/'id'/review
 */
export function POST_REVIEW_TICKET(salesOrderId) {
	return `/current-user/codes/${salesOrderId}/review`
}
// END FUNCTION

// Send ticket codes SMS
/**
 * @param {Object}          ids
 * @returns {string}        /current-user/codes/'id'/sendcodebysms
 */
export function POST_SMS_TICKET(salesOrderId) {
	return `/current-user/codes/${salesOrderId}/sendcodebysms`
}
// END FUNCTION

// Force delete sale code SMS
/**
 * @param {Object}          ids
 * @returns {string}        /current-user/codes/'id'/delete
 */
export function POST_DELETE_SALE_CODE(salesOrderId) {
	return `/current-user/codes/${salesOrderId}/delete`
}
// END FUNCTION

// Cancel sale code SMS
/**
 * @param {Object}          ids
 * @returns {string}        /current-user/codes/'id'/cancel
 */
export function POST_CANCEL_SALE_CODE(salesOrderId) {
	return `/current-user/codes/${salesOrderId}/cancel`
}
// END FUNCTION

// Reactivate code
/**
 * @param {Object}          ids
 * @returns {string}        /current-user/codes/'id'/reactivate
 */
export function POST_RENEW_CODE(salesOrderId) {
	return `/current-user/codes/${salesOrderId}/reactivate`
}
// END FUNCTION

// Distribution group repository
/**
 * @returns {string}        /current-user/items
 */
export function POST_DISTRIBUTION_GROUP(queryParams) {
	return `/current-user/items${createQueryParams(queryParams)}`
}

/**
 * @param {Object}          ids
 * @returns {strng}        /current-user/items/'idItem'/active
 */
export function POST_ACTIVE_ITEM(idItem) {
	return `/current-user/item/${idItem}/active`
}

/**
 * @param {Object}          ids
 * @returns {strng}        /current-user/items/'idItem'/delete
 */
export function POST_DELETE_ITEM(idItem) {
	return `/current-user/item/${idItem}/delete`
}

/**
 * @param {Object}          ids
 * @returns {strng}        /current-user/items/'idItem'/detail
 */
export function GET_ITEM_DETAIL(idItem) {
	return `/current-user/item/${idItem}/detail`
}

// ARTICLE MANAGER
export function GET_ARTICLE_AVAILABLE_LISTS() {
	return `current-user/items-management/create-update/data`
}

export function CREATE_ARTICLE() {
	return `current-user/items-management/create`
}

/**
 *
 * @param {*} idItem
 */
export function GET_ARTICLE_ITEM(idItem) {
	return `current-user/items-management/${idItem}/data`
}

/**
 *
 * @param {*} idItem
 */
export function UPDATE_ARTICLE(idItem) {
	return `current-user/items-management/${idItem}/update`
}

// BIND CATALOG

/**
 * @returns {string}        /current-user/item/catalog/distributor/link
 */
export function POST_BIND_CATALOG(queryParams) {
	return `/current-user/item/catalog/distributor/link${createQueryParams(queryParams)}`
}

/**
 * @param {Object}          ids
 * @returns {strng}       /current-user/item/catalog/distributor/link/'idItem'/add
 */
export function PUT_LINK_CATALOG_ITEM(idItem) {
	return `/current-user/item/catalog/distributor/link/${idItem}/add`
}

/**
 * @param {Object}          ids
 * @returns {strng}       /current-user/item/catalog/distributor/link/'idItem'/remove
 */
export function PUT_UNLINK_CATALOG_ITEM(idItem) {
	return `/current-user/item/catalog/distributor/link/${idItem}/remove`
}

// COMPANIES MANAGER
/**
 *
 * @param {*} queryParams
 */
export function GET_COMPANIES(queryParams) {
	return `/current-user/companies-management${createQueryParams(queryParams)}`
}

/**
 *
 * @param {*} idCompany
 * @param {*} queryParams
 */
export function SET_STATE_COMPANY(idCompany, queryParams) {
	return `/current-user/companies-management/${idCompany}${createQueryParams(queryParams)}`
}

export function GET_COMPANY_AVAILABLE_LISTS() {
	return `/current-user/companies-management/create/data`
}

export function CREATE_COMPANY() {
	return `/current-user/companies-management/create`
}

/**
 *
 * @param {*} id
 */
export function GET_COMPANY_DATA(id) {
	return `/current-user/companies-management/${id}`
}
/**
 *
 * @param {*} id
 */
export function UPDATE_COMPANY(id) {
	return `current-user/companies-management/${id}/update`
}

/**
 *
 * @param {*} id
 */
export function CHECK_DISTRIBUTION_DISABLING(idCompany, idCompanyTyped, isDistributorGroup) {
	return `current-user/companies-management/${idCompany}/partnershipdistribution/${idCompanyTyped}/canDisabled?isDistributorGroup=${isDistributorGroup}`
}

/**
 *
 * @param {*} id
 */
export function DELETE_TECH_SUPPORT(idCompany, idCompanyTyped) {
	return `current-user/companies-management/${idCompany}/partnershipmaintainer/${idCompanyTyped}/canDisabled`
}

/**
 *
 * @param {integer} idCompany
 * @param {integer} smsQuantity
 * @returns {string}
 */
export function PUT_SMS_REFILL(idCompany, smsQuantity) {
	return `current-user/companies-management/${idCompany}/rechargeSms?smsQuantity=${smsQuantity}`
}

/**
 *
 * @param {integer} idCompany
 * @param {integer} idCompanySubgroupPartner
 * @returns {string}
 */
export function PUT_DELETE_COMPANY_SUBGROUP_PARTNERSHIP(idCompany, idCompanySubgroupPartner) {
	return `current-user/companies-management/${idCompany}/companySubGroupPartnership/${idCompanySubgroupPartner}/delete`
}

/**
 *
 * @param {integer} idCompany
 * @param {integer} idCompanySubgroupLink
 * @returns {string}
 */
export function PUT_DELETE_COMPANY_SUBGROUP_LINK(idCompany, idCompanySubgroupLink) {
	return `current-user/companies-management/${idCompany}/groupSubGroupLink/${idCompanySubgroupLink}/delete`
}

// TRANSLATIONS MANAGER
export function GET_LIST_TRANSLATIONS(queryParams) {
	return `/translations${createQueryParams(queryParams)}`
}

/**
 *
 * @param {*} idLanguage
 */
export function SET_TRANSLATION(idLanguage) {
	return `/translations/language/${idLanguage}`
}

// USER PREFERENCES
export function GET_USER_PREFERENCES() {
	return `/current-user/preferences`
}

/**
 *
 * @param {*} idPreference id of the preference
 * @param {*} typeURL type of preference
 * @param {*} selected the value
 */
export function SET_USER_PREFERENCE(idPreference, typeURL, selected) {
	return typeURL === 'price-ttc' && idPreference === ''
		? `/current-user/setting/${typeURL}/update?selected=${selected}`
		: `/current-user/setting/${typeURL}/${idPreference}/update?selected=${selected}`
}

// EXPORT DATAS

/**
 *
 * @returns {stirng}
 */
export function POST_EXPORT_DATAS(url) {
	return url
}
// NOTIFICATIONS

export function GET_LOGS_NOTIFICATION() {
	return `/current-user/logs`
}

/**
 *
 * @param {*} id
 */
export function UPDATE_RESOLVED_LOG(id) {
	return `/current-user/logs/${id}/close`
}

/**
 *
 * @param {*} id
 */
export function CLOSE_NOTIFICATION(id) {
	return `/current-user/logs/${id}/close`
}

export function CLOSE_ALL_NOTIFICATION() {
	return `/current-user/logs/close/all`
}

/**
 *
 * @param {*} id
 */
export function REPORT_NOTIFICATION(id) {
	return `/current-user/logs/${id}/report`
}

export function GET_ARTICLE_LIFE_TIMELINE(id, year) {
	return `/current-user/items-lifecycle/${id}/timeline/graph?middleYear=${year}`
}

export function GET_ARTICLE_LIFE_TIMELINE_PHASES(id) {
	return `/current-user/items-lifecycle/${id}/timeline/phases`
}

/////////////////// START ARTICLE LIFE CYCLE /////////////////////////////

export function GET_HEADER_AND_ACTION_ARTICLE(id) {
	return `/current-user` + `/items-lifecycle` + `/${id}` + `/header`
}

export function POST_DELETE_STOP_DEPOSIT(id) {
	return `/current-user/items-lifecycle/${id}/actions?query=DeleteStopDeposit`
}

export function POST_ADD_STOP_DEPOSIT(id, query) {
	return `/current-user/items-lifecycle/${id}/actions?query=${query}`
}

export function POST_SCHEDULE_ACTIVATE_ACTION(id, query) {
	return `/current-user/items-lifecycle/${id}/actions?query=${query}`
}
// to use only one endpoint in saga
export function POST_LIFE_CYCLE_ACTION(id, query) {
	return `/current-user/items-lifecycle/${id}/actions?query=${query}`
}
export function UPDATE_START_DEPOSIT_ACTION(id) {
	return `/current-user/items-lifecycle/${id}/actions?query=ModifyAddStartWithDepositAction`
}

export function UPDATE_STOP_DEPOSIT_ACTION(id) {
	return `/current-user/items-lifecycle/${id}/actions?query=ModifyStopDeposit`
}
export function POST_DELETE_ADD_START_WITH_DEPOSIT(id) {
	return `/current-user/items-lifecycle/${id}/actions?query=DeleteAddStartWithDepositAction`
}

export function POST_DELETE_SCHEDULED_ACTIVATE(id) {
	return `/current-user/items-lifecycle/${id}/actions?query=DeleteScheduledActivateAction`
}

export function POST_DELETE_DESACTIVATION_SCHEDULED(id) {
	return `/current-user/items-lifecycle/${id}/actions?query=deleteDeactivationAction`
}

export function POST_DELETE_STOP_WITH_RESTOCK(id) {
	return `/current-user/items-lifecycle/${id}/actions?query=deleteStopWithRestockAction`
}

/////////////////// END ARTICLE LIFE CYCLE /////////////////////////////
///////////////////KIOSK MANAGER///////////////////////////////////////
// INIT KIOSK MANAGER
export function GET_INIT_KIOSKS_BUSINESS(queryParams) {
	return `/kiosk-request/business${createQueryParams(queryParams)}`
}

export function GET_INIT_KIOSKS_CUSTOMER(queryParams) {
	return `/kiosk-request/customer${createQueryParams(queryParams)}`
}

// STEP 1
export function GET_KIOSK_CREATION_DEFINITION_CUSTOMER_AVAILABLE_LISTS() {
	return `/kiosk-request/step/kiosk/customer/new-form`
}

export function GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_BYKIOSK(id) {
	return `/kiosk-request/step/kiosk/customer/kiosk/model/config/${id}`
}

export function GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE(idProfile) {
	return `/kiosk-request/step/kiosk/customer/kiosk/config/${idProfile}`
}

export function SAVE_KIOSK_CREATION_DEFINITION_CUSTOMER() {
	return `/kiosk-request/step/kiosk/customer/save`
}

export function CREATE_KIOSK_CREATION_DEFINITION_CUSTOMER() {
	return `/kiosk-request/step/kiosk/customer/create`
}

export function GET_KIOSK_CREATION_DEFINITION_CUSTOMER(id) {
	return `/kiosk-request/step/kiosk/customer/request/${id}/continue`
}

export function GET_KIOSK_CREATION_DEFINITION_BUSINESS_AVAILABLE_LISTS() {
	return `/kiosk-request/step/kiosk/business/new-form`
}

export function GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_BYKIOSK(id) {
	return `/kiosk-request/step/kiosk/business/kiosk/model/config/${id}`
}

export function GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILES(idOwner) {
	return `/kiosk-request/step/kiosk/business/owner/${idOwner}/config`
}

export function SAVE_KIOSK_CREATION_DEFINITION_BUSINESS() {
	return `kiosk-request/step/kiosk/business/save`
}

export function CREATE_KIOSK_CREATION_DEFINITION_BUSINESS() {
	return `kiosk-request/step/kiosk/business/create`
}

export function GET_KIOSK_CREATION_DEFINITION_BUSINESS(id) {
	return `/kiosk-request/step/kiosk/business/request/${id}/continue`
}

export function GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE(idProfile) {
	return `/kiosk-request/step/kiosk/business/kiosk/config/${idProfile}`
}

export function REFRESH_KIOSK_CREATION_DEFINITION_BUSINESS(id) {
	return `/kiosk-request/step/kiosk/business/refresh-form/${id}`
}

// BANK DETAILS
export function GET_KIOSK_CREATION_BANK_DETAILS(idRequest) {
	return `/kiosk-request/step/bank/${idRequest}`
}
export function PUT_SAVE_BANK_DETAILS(idRequest) {
	return `/kiosk-request/step/bank/${idRequest}/save`
}
export function PUT_CONTINUE_BANK_DETAILS(idRequest) {
	return `/kiosk-request/step/bank/${idRequest}/continue`
}

// ADD ITEMS
export function POST_KIOSK_ADD_ITEMS(requestId, queryParams) {
	return `/kiosk-request/step/items/${requestId}${createQueryParams(queryParams)}`
}
export function PUT_KIOSK_LINK_ITEMS(requestId, itemId) {
	return `kiosk-request/step/items/${requestId}/${itemId}/add`
}
export function PUT_KIOSK_UNLINK_ITEMS(idRequest, distriItemId) {
	return `/kiosk-request/step/items/${idRequest}/${distriItemId}/remove`
}
export function GET_KIOSK_ITEMS_VALIDATE(idRequest) {
	return `kiosk-request/step/items/${idRequest}/continue`
}

// ADD PRICES
export function POST_KIOSK_ADD_PRICES(requestId, queryParams) {
	return `/kiosk-request/step/prices/${requestId}${createQueryParams(queryParams)}`
}
export function PUT_UPDATE_PRICES(requestId, action) {
	return `/kiosk-request/step/prices/${requestId}/save?withTTC=${action}`
}
export function PUT_VALIDATE_PRICES(requestId) {
	return `/kiosk-request/step/prices/${requestId}/continue`
}

// KIOSK START & FINISH BUILD
export function PUT_KIOSK_BUILD(requestId, query) {
	return `/kiosk-request/${requestId}/business/modal-actions?query=${query}`
}

// KIOSK IMPLANTATION  kiosk-request/step/growth/1?page=0&size=100
/**
 * @param {string}          requestId
 * @param {object}          queryParams
 * @returns {string}        /current-user/kiosk-request/step/growth/
 */
export function POST_KIOSK_IMPLANTATION(requestId, queryParams) {
	return `/kiosk-request/step/growth/${requestId}${createQueryParams(queryParams)}`
}

/**
 * @param {string}          requestId
 */
export function GET_ITEMS_CATALOG_GROWTH(requestId, requestUrl) {
	return `/kiosk-request/step/growth/${requestId}/${requestUrl}`
}

/**
 * @param {string}          requestId
 * @param {string}          query
 */
export function PUT_UNIT_ACTION_WITH_ID(requestId, query, arg) {
	return `/kiosk-request/step/growth/${requestId}/action?query=${query}${arg}`
}

/**
 * @param {string}          requestId
 */
export function PUT_VALIDATE_IMPLANTATION(requestId) {
	return `/kiosk-request/step/growth/${requestId}/continue`
}

// SUMMARY
export function GET_KIOSK_CREATION_SUMMARY_CUSTOMER(requestId) {
	return `/kiosk-request/step/validation/customer/${requestId}`
}

export function SET_SUMMARY_CONFIG_FINISHED_CUSTOMER(requestId) {
	return `/kiosk-request/step/validation/customer/${requestId}`
}

export function GET_KIOSK_CREATION_SUMMARY_BUSINESS(requestId) {
	return `/kiosk-request/step/validation/business/${requestId}`
}

export function SET_SUMMARY_CONFIG_FINISHED_BUSINESS(requestId) {
	return `/kiosk-request/step/validation/business/${requestId}`
}

export function SET_SUMMARY_TRIGGER_BUILD(requestId) {
	return `/kiosk-request/step/validation/business/${requestId}`
}

// CONSIGNATION
/**
 * @param {object} queryParams
 * @returns {string}    /current-user/marketing
 * @constructor
 */
export function POST_MARKETING(queryParams) {
	return `/marketing${createQueryParams(queryParams)}`
}

// END FUNCTION

// KIOSK PRODUCTION LIST
export function GET_KIOSK_PRODUCTION_LIST(queryParams) {
	return `/kiosks-production${createQueryParams(queryParams)}`
}
export function GET_KIOSK_PRODUCTION_INFOS_SIMCARD(id) {
	return `/kiosks-production/${id}/sim-card`
}
export function GET_KIOSK_PRODUCTION_INFOS_BATTERY(id) {
	return `/kiosks-production/${id}/battery`
}
export function GET_KIOSK_PRODUCTION_INFOS_WS(id) {
	return `/kiosks-production/${id}/web-service`
}

// KIOSK DIAGNOSTIC
/**
 *
 * @param {integer}         idKioskProduction
 * @param {string}          queryParams
 */
export function POST_KIOSK_DIAGNOSTIC(idKioskProduction, queryParams) {
	return `/kiosks-production/${idKioskProduction}/logs${createQueryParams(queryParams)}`
}

/**
 * @param {Object}          ids
 * @returns {strng}        /current-user/items/'idItem'/detail
 */
export function GET_ITEM_CATALOG_DETAIL(idItem) {
	return `/item/catalog/kiosk/${idItem}`
}

// ARTICLES CATALOG
export function GET_ITEM_CATALOG(queryParams) {
	return `/item/catalog/kiosk${createQueryParams(queryParams)}`
}
// SALE BY CODE MODAL
/**
 * @param {Object}          id
 * @returns {string}        salesorder/codes/{idItemKiosk}/view-info
 */
export function GET_SALE_ORDER_BY_CODE(id) {
	return `salesorder/codes/${id}/view-info`
}
/**
 * @returns {string}        salesorder/codes/{idItemKiosk}/view-info
 */
export function POST_CREATE_CODE() {
	return `/salesorder/codes/create`
}
/**
 * @returns {string}        current-user/codes/{id}/sendcodeby${slug}?{urlParam}={email}
 */
export function POST_SEND_CODE(id, slug, urlParam = null, email = null) {
	return !isNull(urlParam) && !isNull(email)
		? `current-user/codes/${id}/sendcodeby${slug}?${urlParam}=${email}`
		: `current-user/codes/${id}/sendcodeby${slug}`
}

// KIOSK EDIT SETUP

/**
 * @param {Object}          id
 * @returns {string}       kiosks-production-edit/${id}/edit-form
 */
export function GET_KIOSK_SETUP(id) {
	return `current-user/kiosks-production-edit/${id}/edit-form`
}

/**
 * @param {Object}          requestId
 * @returns {string}       kiosks-production-edit/${requestId}/update
 */
export function PUT_EDIT_KIOSK_SETUP(requestId) {
	return `current-user/kiosks-production-edit/${requestId}/update`
}

/**
 * @param {Object}          requestId
 * @returns {string}       current-user/kiosks-production-edit/${requestId}/showProductionSheet
 */
export function VIEW_PRODUCTION_FILE(requestId) {
	return `current-user/kiosks-production-edit/${requestId}/showProductionSheet`
}

// KIOSK RACKS REQUEST
/**
 *
 * @param {string} id
 * @returns {string}
 */
export function GET_KIOSK_RACKS_REQUEST(id) {
	return `/rack-request/${id}`
}

/**
 *
 * @returns {string}
 */
export function GET_KIOSK_RACKS_REQUEST_FORM() {
	return `/rack-request/new`
}

/**
 *
 * @param {string} id
 * @returns {string}
 */
export function POST_KIOSK_RACKS_REQUEST_ADD_RACK(id) {
	return `/rack-request/${id}/create`
}

/**
 *
 * @param {string} id
 * @returns {string}
 */
export function POST_KIOSK_RACKS_REQUEST_UPDATE_RACK(id) {
	return `/rack-request/${id}/update`
}

/**
 *
 * @param {string} id
 * @returns {string}
 */
export function POST_KIOSK_RACKS_REQUEST_UPDATE_REQUEST(id) {
	return `/rack-request/request/${id}/update`
}

/**
 *
 * @param {string} id
 * @returns {string}
 */
export function PUT_KIOSK_RACKS_REQUEST_DELETE_REQUEST(id) {
	return `/rack-request/request/${id}/delete`
}

/**
 *
 * @param {string} id
 * @returns {string}
 */
export function PUT_KIOSK_RACKS_REQUEST_DELETE_RACK(id) {
	return `/rack-request/${id}/delete`
}

// KIOSK EDIT IMPLANTATION

/**
 * @param {string}          requestId
 * @param {object}          queryParams
 * @returns {string}
 */
export function POST_KIOSK_EDIT_IMPLANTATION(requestId, queryParams) {
	return `/kiosk-implantation/${requestId}${createQueryParams(queryParams)}`
}

/**
 *
 * @param {string} requestId
 * @param {string} query
 * @param {string} arg
 * @returns {string}
 */
export function POST_KIOSK_EDIT_IMPLANTATION_UNIT_ACTION_WITH_ID(requestId, query, arg) {
	return `/kiosk-implantation/${requestId}/action?query=${query}${arg}`
}

/**
 *
 * @param {string} requestId
 * @param {string} requestUrl
 * @returns {string}
 */
export function GET_KIOSK_EDIT_IMPLANTATION_ITEMS_CATALOG_GROWTH(requestId, requestUrl) {
	return `/kiosk-implantation/${requestId}/${requestUrl}`
}

/**
 *
 * @param {string} requestId
 * @returns {string}
 */
export function PUT_KIOSK_EDIT_IMPLANTATION_VALIDATE_IMPLANTATION(requestId) {
	return `/kiosk-implantation/${requestId}/save`
}

// LANGUAGES MANAGER

/**
 *
 * @param {string} queryParams
 * @returns {string}
 */
export function GET_LANGUAGES(queryParams) {
	return `/languages${createQueryParams(queryParams)}`
}

/**
 *
 * @param {string} id
 * @returns {string}
 */
export function GET_LANGUAGE_DETAIL(id) {
	return `/languages/${id}`
}

export function POST_CREATE_LANGUAGE_DETAIL() {
	return `/languages/create`
}

export function POST_UPDATE_LANGUAGE_DETAIL(id) {
	return `/languages/${id}/update`
}

export function PUT_LANGUAGE_ENABLING(id, enabled) {
	return `/languages/${id}?action=${enabled ? 'enable' : 'disable'}`
}

// TABLE
/**
 *
 * @param {string} idPageTable
 * @returns
 */
export function GET_ALL_SAVED_TABLE_COLUMNS_DISPLAY() {
	return `/user/preference/table`
}

/**
 *
 * @param {string} idPageTable
 * @returns
 */
export function SET_SAVED_TABLE_COLUMNS_DISPLAY() {
	return `/user/preference/table`
}

// sales control
/**
 *
 * @returns {string}        /kiosks-transaction/analysis
 */
export function GET_SALES_CONTROL(ids, queryParams) {
	return `/kiosks-transaction/analysis${createQueryParams(queryParams)}`
}
// END FUNCTION

export function GET_STATISTICS(kioskId, dateStart, dateEnd) {
	return `/kiosk/${kioskId}/statistics?dateStart=${dateStart}&dateEnd=${dateEnd}`
}

export function EXPORT_STATISTICS() {
	return `/kiosk/statistics/export`
}
